import templateUrl from './onboarding-dashboard.component.html'
import { ReviewModal } from '../review-modal/review-modal.component';
import angular from 'angular';
import { InfoModal } from '../info-modal/info-modal.component';

export const DashboardOnboardingComponent = {
    bindings: {
        employee: "<",
        userRole: "<",
        /*applications: "<",*/
        modalTitle: "<",
    },
    templateUrl,
    controllerAs: "vm",
    controller: DashboardOnboardingController
}

export enum OnbTabs {
    All = 0,
    Active = 1,
    Pending = 2,
    Terminated = 3
}

function DashboardOnboardingController(utilityService, employeeService, $state, $q, $timeout,
    onboardingDocumentService, $uibModal, $transitions, permissionGrantService, stateProvinceService) {
    'ngInject';
    const vm = this;
    let defaultFilter;
    vm.applications = [];
    vm.applicationsbk = [];
    vm.userRole;
    vm.modalTitle;
    vm.allComments = [];
    vm.onComment = onComment;
    vm.isLoaded;
    vm.stateProvinces;
    vm.approveApplication = approveApplication;
    vm.removeApplication = removeApplication;
    vm.getButtonTitle = getButtonTitle;
    vm.terminateApplication = terminateApplication;
    vm.isComment = false;
    vm.isChangeRequested = false;
    vm.isEmployerView = false;
    vm.checkApplication = checkApplication;
    vm.pageNumber = 1;
    vm.pageSize = 5;
    vm.activeTab = 'Active'
    vm.activeTabIndex = 0;
    vm.filtersRestored;
    vm.rejectApplication = rejectApplication;
    vm.onboardEmployee = onboardEmployee;

    vm.statusDD = [{ id: 'Created', value: 'Created' }, { id: 'Started', value: 'Started' }, { id: 'Approved', value: 'Approved' }, { id: 'Review', value: 'Review' }, { id: 'Submitted', value: 'Submitted' }, { id: 'Deleted', value: 'Deleted' }];

    vm.saveComment = saveComment;
    vm.fillEmployer = fillEmployer;
    vm.requestChangesModal = requestChangesModal;
    vm.onChangeTab = onChangeTab;
    vm.applicationId;
    vm.selectedApplication;
    vm.filters = {};
    vm.onChangeFilters = onChangeFilters;
    vm.resendOnboardingEmail = resendOnboardingEmail;
    vm.clearDate = clearDate;
    vm.isSortingByField = isSortingByField;
    vm.fillApplication = fillApplication;
    vm.clearFilter = clearFilter;
    vm.columnClass = columnClass;
    vm.rehireEmployee = rehireEmployee;
    vm.onChangePage = onChangePage;
    vm.updateEmployee = updateEmployee;
    vm.sortColumn = { field: "ApplicationNumber", dir: -1 };
    vm.sortClass = (dir: number) => dir > 0 ? "glyphicon fas fa-sort-amount-down-alt" : "glyphicon fas fa-sort-amount-down";
    vm.onSetSort = onSetSort;
    vm.sortData = sortData;
    //vm.getSubmittedFormOwner = getSubmittedFormOwner;
    // variables to manage buttons
    vm.enabledRequestChanges = false;
    vm.enabledApprove = false;
    vm.enableFillEmployer = false;
    vm.filtersRestored;
    vm.approveApplicationForPaper = approveApplicationForPaper;
    vm.changeToPaper = changeToPaper
    vm.changeToOnline = changeToOnline
    vm.navigateToLegacyProfile = navigateToLegacyProfile;
    vm.triggerOnboardingForInactive = triggerOnboardingForInactive;

    vm.$onInit = function () {
        defaultFilter = {};
        defaultFilter.PageNumber = vm.pageNumber;
        defaultFilter.PageSize = vm.pageSize;
        defaultFilter.PageNumberA = vm.pageNumber;
        defaultFilter.PageSizeA = vm.pageSize;
        defaultFilter.PageNumberT = vm.pageNumber;
        defaultFilter.PageSizeT = vm.pageSize;
        defaultFilter.PageNumberP = vm.pageNumber;
        defaultFilter.PageSizeP = vm.pageSize;

        vm.userName = this.employee.UserName;
        vm.applications = this.applications;
        //vm.applications.forEach(function (app) {
        //    app.Complete = app.FederalW4 === 'Submitted' && app.UserProfile === 'Submitted' && app.I9Form === 'Submitted' && app.DirectDeposit === 'Submitted' && (app.ProvinceW4 === 'Submitted' || app.ProvinceW4 === 'NotRequired')
        //});
        vm.applicationsbk = angular.copy(vm.applications);
        if (vm.userRole) {
            vm.isOwner = vm.userRole === 'Owner' || vm.userRole === 'PayrollAdmin';
            vm.isEmployee = vm.userRole === 'Employee';
            vm.usrRole = vm.userRole;

            const filtersRestored = restoreFilters();
            const promises = [];

            promises.push(filtersRestored);

            if (vm.isOwner) {
                vm.activeTabIndex = 2;
                promises.push(loadApplications(OnbTabs.Pending));
                /*onChangeTab(OnbTabs.Pending);*/
            } else {
                vm.activeTabIndex = 0;
                promises.push(loadApplications(OnbTabs.All));
                //onChangeTab(OnbTabs.All);
            }

            promises.push(retrieveStateProvinces());
            var tabNames = ['All', 'Active', 'Pending', 'Terminated'];
            vm.activeTab = tabNames[vm.activeTabIndex];

            if (vm.isOwner) {
                onChangeTab(OnbTabs.Pending);
            } else {
                onChangeTab(OnbTabs.All);
            }

            const initLoad = $q.all(promises).then((res) => {
                console.log(res);
            });
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(initLoad), "Changing page failed");
        }
    }

    function retrieveStateProvinces() {
        return stateProvinceService.retrieveStateProvinces().then((res) => {
            vm.stateProvinces = res;
        });
    }


    function rejectApplication(app) {
        if (app.IsTelemapperLinked) {
            alert('Please be aware that your company is linked with Telemapper and terminations have to be processed in Telemapper.');
        } else {
            //if (app.ApplicationStatus === 'Created') {
            //    var confirmDelete = confirm("Please confirm that you would like to terminate this onboarding application.");

            //    if (!confirmDelete) {
            //        return; // cancel the action
            //    }

            //    // delete profile
            //    return terminateApplication(app.ApplicationNumber);
            //} else {
            return terminateApplication(app.ApplicationNumber);
            //}
        }
    }

    function updateEmployee(employeeId) {
        $state.go('application-status.pendingModal', { employeeId: employeeId, icdOfficeID: vm.icdOfficeID });
    }

    function loadApplications(active) {
        let query = {
            PageSize: vm.filters.PageSize,
            UserName: vm.employee.UserName,
            Id: vm.filters.applicationNumber,
            EmployeeName: vm.filters.employeeName,
            OwnerName: vm.filters.owner,
            UserProfile: vm.filters.userProfile,
            FedW4W9: vm.filters.federalW4,
            ProvinceW4: vm.filters.stateW4,
            I9: vm.filters.i9,
            DirectDeposit: vm.filters.directDeposit,
            ProfileStatus: vm.filters.status,
            AccountStatus: vm.filters.employeeStatus,
            Department: vm.filters.dept,
            SortFields: vm.filters.SortFields,
            EmployeeStatus: 0
        };
        let pageNum = vm.filters.PageNumber;
        if (active === OnbTabs.Active) {
            query.EmployeeStatus = 1;
            pageNum = vm.filters.PageNumberA;
        } else if (active === OnbTabs.Pending) {
            query.EmployeeStatus = 2;
            pageNum = vm.filters.PageNumberP;
        } else if (active === OnbTabs.Terminated) {
            query.EmployeeStatus = 3;
            pageNum = vm.filters.PageNumberT;
        } else {
            query.EmployeeStatus = 0;
        }
        return loadApplicationsPage(query, pageNum).then(function (page) {
            if (active === OnbTabs.Active) {
                vm.applicationsPageAct = page;
                vm.applicationsAct = page.Entities;
            } else if (active === OnbTabs.Pending) {
                vm.applicationsPagePen = page;
                vm.applicationsPen = page.Entities;
            } else if (active === OnbTabs.Terminated) {
                vm.applicationsPageTerm = page;
                vm.applicationsTerm = page.Entities;
            } else {
                vm.applicationsPage = page;
                vm.applications = page.Entities;
            }
            vm.isLoaded = true;
        });
    }

    function onboardEmployee(employeeId) {
        $state.go('application-status.pendingModal', { employeeId: employeeId, icdOfficeID: vm.icdOfficeID, onboard: true })
            .then(function () {
                // success
            })
            .catch(function (err) {
                // navigation failed
            });
    }

    function changeToPaper(application) {
        $uibModal.open({
            ...InfoModal,
            resolve: {
                notification: () => "You're about to switch this profile to a paper application. You will need to ensure that paper copies are kept with your organization for 7 years. Would you like to continue?",
                cancel: () => "Cancel",
                continue: () => "Proceed"
            },
            controller: function ConfirmModalController($uibModalInstance) {
                'ngInject';
                this.proceed = function () {
                    $uibModalInstance.close('ok'); // returns 'ok' when user confirms
                };
                this.cancel = function () {
                    $uibModalInstance.dismiss(); // dismiss modal if canceled
                };
            },
            controllerAs: '$ctrl',
            size: 'sm',
            backdrop: 'static',
            template: `
            <div class="modal-header">
                <h5 class="modal-title">Confirmation</h5>
            </div>
            <div class="modal-body">
                {{ $ctrl.notification }}
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" ng-click="$ctrl.cancel()">{{ $ctrl.cancelText || 'Cancel' }}</button>
                <button class="btn btn-primary" ng-click="$ctrl.proceed()">{{ $ctrl.continueText || 'Proceed' }}</button>
            </div>
        `
        }).result.then(function (data) {
            if (data === 'ok') {
                const change = onboardingDocumentService.changeApplicationToPaper(application.ApplicationNumber);
                utilityService.showLoadingUntilResolved(
                    change.catch(err => utilityService.alertOnError(err)),
                    "Changing application type failed"
                ).then(() => {
                    navigateToLegacyProfile(application.EmployeeId);
                });
            }
        }, function () {
            console.log('Modal dismissed');
        });
    }


    function navigateToLegacyProfile(employeeID) {
        return $state.go("employee.edit", {
            employeeID: employeeID
        });
    }

    function triggerOnboardingForInactive(employeeId) {
        const init = employeeService.initOnboardingEmployee(employeeId, true).then((res) => {
            console.log(res);
            return loadApplications(vm.activeTab);
        }).then(() => {
            console.log("Success");
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(init, "Error Initiating Onboarding"));
    }

    function changeToOnline(application) {
        //const change = onboardingDocumentService.changeApplicationToOnline(application.ApplicationNumber).then((res) => {
        //    console.log(res);
        //    return loadApplications(vm.activeTab);
        //});
        //utilityService.showLoadingUntilResolved(
        //    utilityService.alertOnError(change), "Changing page failed");


        $uibModal.open({
            ...InfoModal,
            resolve: {
                notification: () => "You're about to switch this profile to an online application. Would you like to continue?",
                cancel: () => "Cancel",
                continue: () => "Proceed",
                //state: () => ""
            },
            controller: function ConfirmModalController($uibModalInstance) {
                'ngInject'
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            size: 'sm',
            backdrop: 'static'
        }).result.then(function (data) {
            console.log(data);
            if (data === 'ok') {
                const change = onboardingDocumentService.changeApplicationToOnline(application.ApplicationNumber);
                change.then((res) => {
                    console.log(res);
                    $state.reload();
                });
                utilityService.showLoadingUntilResolved(
                    utilityService.alertOnError(change), "Changing application type failed"
                );
            }
        }, function (dismiss) {
            console.log('dismissed');
        });
    }

    function approveApplicationForPaper(requestTypeId: string, application: any) {
        console.log(requestTypeId);
        if (!application.ProvinceW4ExemptChoice) {
            alert("The tax form will be coming in the future. Until then, please ensure that you are completing the paper form outside of Apex.");
        }
        return $state.go("application-status.owner-provinceW4-preview", { applicationId: application.ApplicationNumber });
    }

    function loadApplicationsPage(query, pageNumber) {
        return onboardingDocumentService.retrieveApplicationPage(pageNumber - 1, query)
    }

    function onChangePage() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadApplications(vm.activeTab), "Changing page failed"));
        saveFilters();
    }

    function terminateApplication(appNo) {
        $state.go('application-status.termination', { appId: appNo });
    }

    function saveActiveTab() {
        localStorage.setItem("dashboardTabIndex", vm.activeTabIndex || 0);
    }

    //function getActiveTab() {
    //    return Number(localStorage.getItem("dashboardTabIndex") || vm.activeTabIndex);
    //}
    function rehireEmployee(employeeID) {
        $state.go('application-status.pendingModal', { employeeId: employeeID, icdOfficeID: vm.icdOfficeID, rehire: true });
    }

    function resendOnboardingEmail(employeeId) {
        utilityService.showLoading();
        return employeeService.resendOnboardingEmployee(employeeId).then((res) => {
            utilityService.hideLoading();
            alert("Email sent successfully");
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Sending Email Failed: " + utilityService.getExceptionMessage(err));
        });
    }

    function columnClass(field) {
        return vm.sortColumn.dir === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function isSortingByField(field) {
        return vm.sortColumn.field === field
    }

    function onSetSort(field) {

        if (!vm.filters) {
            vm.filters = {}; // Initialize filters if not already defined
        }
        if (!vm.filters.SortFields) {
            vm.filters.SortFields = []; // Initialize SortFields if not already defined
        }

        if (vm.isSortingByField(field)) {
            vm.sortColumn.dir = vm.sortColumn.dir * -1;
        } else {

            vm.sortColumn.dir = 1;
        }
        vm.sortColumn.field = field;
        vm.filters.SortFields = [(vm.sortColumn.dir === -1 ? "-" : "") + field];
        /*vm.sortData();*/
        saveFilters();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([loadApplications(OnbTabs.All), loadApplications(OnbTabs.Pending)]), "Sorting Failed"));
    }

    function sortData() {
        if (!vm.sortColumn.field) return;

        const field = vm.sortColumn.field;
        const dir = vm.sortColumn.dir;
        vm.filterDocs.sort((a, b) => {
            const valA = a[field];
            const valB = b[field];

            if (valA < valB) return dir * -1;
            if (valA > valB) return dir * 1;
            return 0;
        });


        vm.applications = vm.filterDocs;
        vm.totalItems = vm.applications.length;
    }

    function clearFilter() {

        vm.filters.applicationNumber = '';
        vm.filters.startDate = null;
        vm.filters.endDate = null;
        vm.filters.createdBy = '';
        vm.filters.owner = '';
        vm.filters.status = '';
        vm.filters.employeeName = '';
        vm.filters.userProfile = '';
        vm.filters.federalW4 = '';
        vm.filters.stateW4 = '';
        vm.filters.i9 = '';
        vm.filters.directDeposit = '';
        vm.filters.employeeStatus = '';
        vm.filters.dept = '';

        vm.filterDocs = vm.applicationsbk;

        if (vm.activeTab === 'Pending') {
            vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Pending'))
        } else if (vm.activeTab === 'Active') {
            vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Active'))
        } else if (vm.activeTab === 'Terminated') {
            vm.filterDocs = vm.filterDocs.filter(x => x.EmployeeStatus.includes('Terminated'))
        } else {
            vm.filterDocs = vm.filterDocs
        }



        vm.applications = vm.filterDocs;
    }

    $transitions.onSuccess({ to: 'application' }, function () {
        console.log('load stop');
        utilityService.hideLoading();
    });

    function onChangeTab(tab) {
        /*vm.filterDocs = vm.applicationsbk;*/
        vm.activeTab = tab;

        vm.filters.PageNumber = 1;
        vm.filters.PageNumberA = 1;
        vm.filters.PageNumberP = 1;
        vm.filters.PageNumberT = 1;
        //clearFilter();
        saveActiveTab();
        //restoreFilters();

        loadApplications(vm.activeTab);
    }

    function fillApplication(requestTypeId: string, application: any) {
        switch (requestTypeId) {
            case "6":
                $state.go("application-status.profile");
                break;
            case "5":
                $state.go("application-status.federalW4");
                break;
            case "-2":
                $state.go("application-status.w9");
                break;
            case "2":
                $state.go("application-status.provinceW4");
                break;
            case "3":
                $state.go("application-status.i9");
                break;
            case "7":
                $state.go("application-status.dd");
                break;
            case "9":
                $state.go("application-status.ct");
                break;
            case "confirmation":
                $state.go("application-status.confirmation");
                break;
        }
    }

    function checkApplication(requestTypeId: string, application: any) {
        switch (requestTypeId) {
            case "6":
                $state.go("application-status.owner-profile", { applicationId: application.ApplicationNumber });
                break;
            case "5":
                $state.go("application-status.owner-federalW4-preview", { applicationId: application.ApplicationNumber });
                break;
            case "-2":
                $state.go("application-status.owner-w9-preview", { applicationId: application.ApplicationNumber });
                break;
            case "2":
                $state.go("application-status.owner-provinceW4-preview", { applicationId: application.ApplicationNumber });
                break;
            case "3":
                $state.go("application-status.owner-i9", { applicationId: application.ApplicationNumber });
                break;
            case "7":
                $state.go("application-status.owner-dd", { applicationId: application.ApplicationNumber });
                break;
            case "9":
                $state.go("application-status.owner-ct", { applicationId: application.ApplicationNumber });
                break;
            case "confirmation":
                $state.go("application-status.confirmation");
                break;
        }
    }

    function approveApplication(applicationId: any, employeeId: any) {
        utilityService.showLoading();
        vm.applicationId = applicationId;

        onboardingDocumentService.approveApplication(applicationId, employeeId)
            .then(function (result) {
                //vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Loading Comment Failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function removeApplication(applicationId: any) {
        utilityService.showLoading();
        vm.applicationId = applicationId;

        onboardingDocumentService.removeApplication(applicationId)
            .then(function (result) {
                //vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            }).then(function (res) {
                if (res) {
                    $state.reload();
                }
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Loading Comment Failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function saveComment() {
        utilityService.showLoading();
        vm.userName = vm.employee.UserName;
        onboardingDocumentService.saveComment({
            ApplicationId: vm.applicationId,
            UserName: vm.employee.UserName,
            Text: vm.commentText
        }).then(function (isSaved) {
            if (isSaved === true) {
                onboardingDocumentService.retrieveComments(vm.applicationId)
                    .then(function (comments) {
                        vm.commentText = '';
                        vm.allComments[0] = comments;
                        utilityService.hideLoading();
                    })
                    .catch((err) => {
                        utilityService.hideLoading();
                        alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
                    })
            } else {
                utilityService.hideLoading();
                alert("Saving Comment failed");
            }
            return isSaved;
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Saving Comment failed: " + utilityService.getExceptionMessage(err));
        })
    }


    function requestChangesModal(application: any) {
        utilityService.showLoading();
        var prom2 = employeeService.retrieveEmployeeBankInfo(application.EmployeeId);
        let prom1 = onboardingDocumentService.retrieveComments(application.ApplicationId);
        $q.all([prom1, prom2])
            .then(function (result) {
                utilityService.hideLoading();
                return $uibModal.open({
                    ...ReviewModal,
                    resolve: {
                        title: () => "Review Request",
                        allComments: () => result[0],
                        stateProvince: () => result[1],
                        application: () => application,
                        employee: () => vm.employee
                    }
                }).result
                //vm.allComments[0] = result;
                //vm.isChangeRequested = true;
                //vm.applicationId = application.ApplicationId;
                //vm.selectedApplication = application;
                //console.log(vm.selectedApplication);
                //return result;
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Loading Comment Failed: " + utilityService.getExceptionMessage(err));
            })

    }

    function onComment(applicationId: any) {
        utilityService.showLoading();
        $state.go('application-status.comments', {
            appId: applicationId,
            userName: vm.employee.UserName
        });
    }

    function fillEmployer(application: any) {
        //return $state.go("application-status.ownermodal");
        /*utilityService.showLoading();*/
        $state.go("application-status.ownermodal", {
            applicationId: application.ApplicationId,
            employeeId: application.EmployeeId
        });
    }
    function saveFilters() {
        localStorage.setItem("listonboardlistFiltersDashboard", JSON.stringify(vm.filters || {}));
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listonboardlistFiltersDashboard")) || defaultFilter;
        //vm.filters.employeeName = "009";
        vm.filters.PageNumber = vm.filters.PageNumber || vm.pageNumber;
        vm.filters.PageSize = vm.filters.PageSize || vm.pageSize;
        vm.filters.PageNumberA = vm.filters.PageNumberA || vm.pageNumber;
        vm.filters.PageSizeA = vm.filters.PageSizeA || vm.pageSize;
        vm.filters.PageNumberT = vm.filters.PageNumberT || vm.pageNumber;
        vm.filters.PageSizeT = vm.filters.PageSizeT || vm.pageSize;
        vm.filters.PageNumberP = vm.filters.PageNumberP || vm.pageNumber;
        vm.filters.PageSizeP = vm.filters.PageSizeP || vm.pageSize;

        if (vm.filters.SortFields && vm.filters.SortFields.length > 0) {
            // Check the first character of the first sort.
            vm.sortDirection = vm.filters.SortFields[0][0] === "-" ? -1 : 1;
            vm.sortField = vm.filters.SortFields[0].replace("-", "");
            // Keep sortColumn (drives the onSetSort toggle + header indicator) in sync with
            // the restored sort, otherwise the first click after a reload fails to toggle.
            vm.sortColumn = { field: vm.sortField, dir: vm.sortDirection };
        }
        //onChangeFilters();
        return $q.when();
    }
    let onChangeFiltersTimer;
    function onChangeFilters() {
        if (onChangeFiltersTimer) $timeout.cancel(onChangeFiltersTimer);
        onChangeFiltersTimer = $timeout(function () {
            vm.filters.PageNumber = 1;
            vm.filters.PageNumberA = 1;
            vm.filters.PageNumberT = 1;
            vm.filters.PageNumberP = 1;
            saveFilters();
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError($q.all([loadApplications(OnbTabs.All), loadApplications(OnbTabs.Pending)]), "Filtering failed"));
        }, 300);
    }

    function clearDate(fieldId) {
        console.log(fieldId)
        var datePicker = $("#" + fieldId).data("kendoDatePicker");
        if (datePicker) {
            datePicker.value(null); // Clear the date
            if (fieldId === "StartDate") {
                vm.filters.startDate = null;
            }
            if (fieldId === "EndDate") {
                vm.filters.endDate = null;
            }
        }
    }

    function getButtonTitle(requestTypeId, app) {
        switch (requestTypeId) {
            case "6":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.UserProfile === 'Review' || app.UserProfile === 'Submitted') ? "Update" : "Fill";
            case "5":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.FederalW4 === 'Review' || app.FederalW4 === 'Submitted') ? "Update" : "Fill";
            case "-2":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.W9 === 'Review' || app.W9 === 'Submitted') ? "Update" : "Fill";
            case "2":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.ProvinceW4 === 'Review' || app.ProvinceW4 === 'Submitted') ? "Update" : "Fill";
            case "3":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.I9Form === 'Review' || app.I9Form === 'Submitted') ? "Update" : "Fill";
            case "7":
                return (app.ApplicationStatus === 'Approved' || app.ApplicationStatus === 'Submitted') ? "View" : (app.DirectDeposit === 'Review' || app.DirectDeposit === 'Submitted') ? "Update" : "Fill";
            case "confirmation":
                return "";
        }
    }




}
